import format from 'date-fns/format';
import da from 'date-fns/locale/da';

export function toDate(seconds: number): Date {
    const epochTime = new Date(1970, 0, 1); // Epoch
    epochTime.setSeconds(seconds);
    return epochTime;
}

export function getTimeDiffInSeconds(start: Date, end: Date) {
    if (start > end) {
        throw new Error('BOI.SPA: Start time cannot be after end time.');
    }

    return (end.getTime() - start.getTime()) / 1000;
}

export function convertToLocalDate(date: Date) {
    return new Date(date.toString() + ' UTC');
}

export function formatISODateToString(date: string | undefined) {
    if (!date) {
        return '';
    }

    return format(new Date(date), 'dd. MMMM yyyy', {
        locale: da,
    });
}
